export default "__VITE_ASSET__Ce8FP8Yf__"